import Vue from 'vue'
import Router from 'vue-router'
import HomePage from './views/HomePage.vue'
import ContentPage from './views/ContentPage.vue'
import AdminPage from './views/AdminPage.vue'
import MallPage from './views/MallPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/story', name: 'story', component: ContentPage, props: { pageKey: 'brand.story', eyebrow: 'OUR STORY' } },
    { path: '/products', name: 'products', component: ContentPage, props: { pageKey: 'products.intro', eyebrow: 'THE COLLECTION' } },
    { path: '/products/:id', name: 'product-detail', component: ContentPage, props: { pageKey: 'products.intro', eyebrow: 'PRODUCT' } },
    { path: '/reservation', name: 'reservation', component: ContentPage, props: { pageKey: 'reservation.intro', eyebrow: 'MAKE IT YOURS' } },
    { path: '/cooperation', name: 'cooperation', component: ContentPage, props: { pageKey: 'cooperation.intro', eyebrow: 'GROW TOGETHER' } },
    { path: '/careers', name: 'careers', component: ContentPage, props: { pageKey: 'jobs.intro', eyebrow: 'CAREERS' } },
    { path: '/contact', name: 'contact', component: ContentPage, props: { pageKey: 'store.info', eyebrow: 'FIND YOUR WAY' } },
    { path: '/mall', name: 'mall', component: MallPage },
    { path: '/admin', name: 'admin', component: AdminPage }
  ],
  scrollBehavior() { return { x: 0, y: 0 } }
})